import SellBooksTable from "Components/Admin/AdminSellBooks/SellBooksTable";
import {
  AdminSellBook
} from "Types";
import { useGetAllSellBooksQuery, useUpdateSellBookStatusMutation } from "Services/Admin";
import { useEcomConfig } from "hooks";
import { Header } from "Components/Admin/StyleComponent/Header";
import { FC, useEffect, useState } from "react";



const AdminSellBooks: FC = () => {
  const { showSellBooks } = useEcomConfig();
  const {
    data: sellBooks = [],
    isLoading,
    isError,
    refetch,
  } = useGetAllSellBooksQuery();

  const [updateBookStatus] = useUpdateSellBookStatusMutation();

  const [filteredBooks, setFilteredBooks] = useState<AdminSellBook[]>([]);
  const [selectedBookId, setSelectedBookId] = useState<number | null>(null);
  const [filterOption, setFilterOption] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    let filtered = [...sellBooks];

    if (filterOption !== "All") {
      filtered = filtered.filter((b) => b.status === filterOption);
    }

    if (searchText) {
      filtered = filtered.filter(
        (b) =>
          b.fullName?.toLowerCase().includes(searchText.toLowerCase()) ||
          b.mobileNumber?.includes(searchText) ||
          b.bookTitle?.toLowerCase().includes(searchText.toLowerCase()),
      );
    }

    setFilteredBooks(filtered);
    setCurrentPage(1);
  }, [sellBooks, filterOption, searchText]);

  const handleUpdateStatus = async (
    id: number,
    status: "Purchased" | "Rejected",
  ) => {
    try {
      await updateBookStatus({ id, status }).unwrap();
      refetch();
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  const totalPages = Math.ceil(filteredBooks.length / itemsPerPage);
  const currentBooks = filteredBooks.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

 if (isLoading) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="w-10 h-10 border-4 border-orange-400 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

  if (isError) {
    return <p className="p-6 text-red-500">Failed to load sell books</p>;
  }

  return (
    <div className="font-body p-6 mx-auto">
      <Header title="Sell Books" />

      <div className="bg-white rounded-lg border shadow-sm p-4">
        <div className="flex justify-between mb-4 gap-4 flex-wrap">
          <input
            type="text"
            placeholder="Search by name, mobile, or book title"
            className="border px-3 py-1"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />

          <select
            className="border px-3 py-1"
            value={filterOption}
            onChange={(e) => setFilterOption(e.target.value)}
          >
            <option value="All">All Status</option>
            <option value="Pending">Pending</option>
            <option value="Purchased">Purchased</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>

        <SellBooksTable
          books={currentBooks}
          selectedId={selectedBookId}
          onSelect={(id) => setSelectedBookId(id)}
          onUpdateStatus={handleUpdateStatus}
        />

        <div className="flex justify-between mt-4 text-sm">
          <span>
            Showing {currentBooks.length} of {filteredBooks.length}
          </span>

          <div className="flex gap-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              &lt;
            </button>
            <span className="px-3 py-1">
              Page {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSellBooks;
